"use client";

import type { SupTransactionType } from "@/types";
import React, { useMemo } from "react";

import { useStoredData, useStoredDataDispatch } from "@/store/Context";
import { SupShoppingBag } from "@repo/core-ui";

export default function LayoutMenuCart() {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const { depositCount, withdrawCount, targetCart } = useMemo(() => {
    return {
      depositCount: storedData.cart.length > 9 ? "9+" : storedData.cart.length.toString(),
      withdrawCount: storedData.withdrawCart.length > 9 ? "9+" : storedData.withdrawCart.length.toString(),
      targetCart: storedData.cart.length > 0 || storedData.withdrawCart.length < 1 ? "deposit" : ("withdraw" as SupTransactionType),
    };
  }, [storedData.withdrawCart, storedData.cart]);

  const handleCartClick = () => {
    if (storedData.overlay && ["deposit", "withdraw"].includes(storedData.overlay)) {
      storedDispatch({ type: "closeOverlay" });
    } else {
      storedDispatch({ type: "setOverlay", overlay: targetCart });
    }
  };

  return (
    <button
      type="button"
      className="btn-icon relative z-20 flex h-10 w-10 cursor-pointer items-center justify-center hover:bg-primary-75 hover:text-neutral-950"
      onClick={handleCartClick}
    >
      <SupShoppingBag className="h-auto w-5 stroke-0 transition-all delay-75 duration-100 ease-in" />
      <div className="absolute right-0 h-6 w-3 overflow-hidden text-center font-mono text-[10.8px] leading-3 tracking-[.5px] text-neutral">
        <div className="h-1/2 w-full bg-primary-800 text-neutral-25">{depositCount}</div>
        <div className="h-1/2 w-full bg-primary-100 text-primary-900">{withdrawCount}</div>
      </div>
    </button>
  );
}
